import { render, staticRenderFns } from "./SalaryEffectForm.vue?vue&type=template&id=3aadbf46&"
import script from "./SalaryEffectForm.vue?vue&type=script&lang=js&"
export * from "./SalaryEffectForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports